/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InterrogatoryQueryProcessingData,
    InterrogatoryQueryProcessingDataFromJSON,
    InterrogatoryQueryProcessingDataFromJSONTyped,
    InterrogatoryQueryProcessingDataToJSON,
    InterrogatoryQueryStatus,
    InterrogatoryQueryStatusFromJSON,
    InterrogatoryQueryStatusFromJSONTyped,
    InterrogatoryQueryStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface InterrogatoryQuery
 */
export interface InterrogatoryQuery {
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQuery
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof InterrogatoryQuery
     */
    interrogatoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQuery
     */
    documentId?: string;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQuery
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQuery
     */
    startedByUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQuery
     */
    interrogatoryText?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof InterrogatoryQuery
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InterrogatoryQuery
     */
    completedDate?: Date | null;
    /**
     * 
     * @type {InterrogatoryQueryStatus}
     * @memberof InterrogatoryQuery
     */
    status?: InterrogatoryQueryStatus;
    /**
     * 
     * @type {InterrogatoryQueryProcessingData}
     * @memberof InterrogatoryQuery
     */
    data?: InterrogatoryQueryProcessingData;
    /**
     * 
     * @type {string}
     * @memberof InterrogatoryQuery
     */
    processingErrorText?: string | null;
}

export function InterrogatoryQueryFromJSON(json: any): InterrogatoryQuery {
    return InterrogatoryQueryFromJSONTyped(json, false);
}

export function InterrogatoryQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterrogatoryQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'interrogatoryId': !exists(json, 'interrogatoryId') ? undefined : json['interrogatoryId'],
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'startedByUserId': !exists(json, 'startedByUserId') ? undefined : json['startedByUserId'],
        'interrogatoryText': !exists(json, 'interrogatoryText') ? undefined : json['interrogatoryText'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'completedDate': !exists(json, 'completedDate') ? undefined : (json['completedDate'] === null ? null : new Date(json['completedDate'])),
        'status': !exists(json, 'status') ? undefined : InterrogatoryQueryStatusFromJSON(json['status']),
        'data': !exists(json, 'data') ? undefined : InterrogatoryQueryProcessingDataFromJSON(json['data']),
        'processingErrorText': !exists(json, 'processingErrorText') ? undefined : json['processingErrorText'],
    };
}

export function InterrogatoryQueryToJSON(value?: InterrogatoryQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'interrogatoryId': value.interrogatoryId,
        'documentId': value.documentId,
        'userId': value.userId,
        'startedByUserId': value.startedByUserId,
        'interrogatoryText': value.interrogatoryText,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'completedDate': value.completedDate === undefined ? undefined : (value.completedDate === null ? null : value.completedDate.toISOString()),
        'status': InterrogatoryQueryStatusToJSON(value.status),
        'data': InterrogatoryQueryProcessingDataToJSON(value.data),
        'processingErrorText': value.processingErrorText,
    };
}


